import React, { memo } from 'react';
import classNames from 'classnames';

import css from './style.scss';

const backgroundUrl = (imageUrl, image) => {
  const url = imageUrl(image);
  return url ? `url(${url})` : null;
};

// Read-only website render, shared by the editor preview and the template picker tiles.
const WebsitePreview = ({ banner, logo, images, headerText, bodyText, imageUrl, className }) => (
  <div className={classNames(css.preview, className)}>
    <div className={css.banner} style={{ backgroundImage: backgroundUrl(imageUrl, banner.image) }}>
      {!logo.image ? null : <img className={css.logo} src={imageUrl(logo.image)} alt="" style={{ width: `${logo.width || 172}px` }} />}
      <div className={css.interested}>
        <div>Are You Interested?</div>
        <a className={css.btn} href="#contact-form" tabIndex={-1}> Contact Us </a>
      </div>
    </div>
    <div className={css.content}>
      <div className={css.title} dangerouslySetInnerHTML={{ __html: headerText }} />
      <div className={css.text} dangerouslySetInnerHTML={{ __html: bodyText }} />
      {!images.filter(i => i.image).length ? null : (
        <div className={css.gallery}>
          <div className={css.items}>
            <a className={css.item} style={{ backgroundImage: backgroundUrl(imageUrl, images[0].image) }}>&nbsp;</a>
            <div className={css.items}>
              {[1, 2, 3, 4].map(i => (
                <a key={i} className={css.item} style={{ backgroundImage: backgroundUrl(imageUrl, images[i] && images[i].i ? images[i].image : null) }}>&nbsp;</a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
    <div className={css.contact}>
      <div className={css.title}>
        CONTACT <span>US</span>
      </div>
      <input type="text" name="name" placeholder="NAME" className={css.field} tabIndex={-1} />
      <input type="text" name="email" placeholder="EMAIL" className={css.field} tabIndex={-1} />
      <input type="text" name="phone" placeholder="PHONE" className={css.field} tabIndex={-1} />
      <textarea name="message" placeholder="MESSAGE" tabIndex={-1} />
      <input type="submit" value="SEND" className={css.field} tabIndex={-1} />
    </div>
  </div>
);

export default memo(WebsitePreview);
